import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Skill } from 'src/app/dto';


// skill-badge.component.ts
@Component({
  selector: 'app-skill-badge',
  standalone: true,
  imports: [CommonModule],
  template: `
<a *ngIf="skill.link; else noLink"
       [href]="skill.link"
       target="_blank"
       rel="noopener noreferrer"
       class="group block">

      <ng-container *ngTemplateOutlet="badge"></ng-container>
    </a>

    <ng-template #noLink>
      <div class="group">
        <ng-container *ngTemplateOutlet="badge"></ng-container>
      </div>
    </ng-template>

    <ng-template #badge>
      <div
        [class]="'relative flex items-center gap-3 p-3 rounded-xl border transition-all duration-300 hover:-translate-y-1 cursor-pointer ' + categoryClasses">

        <div class="absolute inset-0 rounded-xl bg-current opacity-0 group-hover:opacity-[0.03] transition-opacity"></div>

        <div class="flex-shrink-0 size-8 rounded-lg bg-black/5 dark:bg-white/5 flex items-center justify-center font-bold text-xs">
          {{ skill.name.substring(0, 2).toUpperCase() }}
        </div>

        <div class="flex flex-col flex-grow">
          <span class="font-display font-semibold text-sm leading-tight text-foreground">
            {{ skill.name }}
          </span>

          <div class="flex gap-1 mt-1.5" *ngIf="hasProficiency()">
            <div *ngFor="let dot of [1,2,3,4,5]; let i = index"
                 class="h-1 w-3 rounded-full transition-all duration-500"
                 [style.background-color]="i < (skill.proficiency / 20) ? 'currentColor' : 'rgba(128,128,128,0.2)'">
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  `
})
export class SkillBadgeComponent {
  @Input({ required: true }) skill!: any;

  get categoryClasses(): string {
    const category = this.skill?.category?.toLowerCase();
    switch (category) {
      case 'libs': return 'text-purple-500 border-purple-500/20 bg-purple-500/5';
      case 'frameworks': return 'text-emerald-500 border-emerald-500/20 bg-emerald-500/5';
      case 'tools': return 'text-amber-500 border-amber-500/20 bg-amber-500/5';
      case 'languages': return 'text-blue-500 border-blue-500/20 bg-blue-500/5';
      default: return 'text-primary border-primary/20 bg-primary/5';
    }
  }

  hasProficiency(): boolean {
    return typeof this.skill?.proficiency === 'number';
  }
}